export default __webpack_public_path__ + "static/media/DtVjJx26TKEr37c9aBVJn3YO5gg.286f140e.woff2";